import _typeof from '@babel/runtime/helpers/typeof';
import _isEmpty from 'lodash.isempty';

var isBoolean = function isBoolean(bool) {
  return typeof bool === "boolean" || _typeof(bool) === "object" && bool !== null && bool.valueOf && typeof bool.valueOf() === "boolean";
};
function isPlainObject(maybeObj) {
  if (isObject(maybeObj) === false) return false;
  var ctor = maybeObj.constructor;
  if (ctor === void 0) return true;
  var prot = ctor.prototype;
  if (isObject(prot) === false) return false;

  if (prot.hasOwnProperty("isPrototypeOf") === false) {
    return false;
  }

  return true;
}

function isObject(maybeObj) {
  return Object.prototype.toString.call(maybeObj) === "[object Object]";
}

function isEmpty(val) {
  return _isEmpty(val);
}

export { isBoolean, isEmpty, isPlainObject };
